import Input from "components/input"
import { ScoringForm } from "pages/scoring"
import { Dispatch, FunctionComponent, SetStateAction, useEffect } from "react"
import { carEvaluation } from "utils/constants"
import styles from "./AutoForm.module.scss"

export interface AutoForm extends ScoringForm {
  property_value: string
  property_age_at_end: string
  car_evaluation_score: string
}

interface Props {
  form: AutoForm
  setForm: Dispatch<SetStateAction<AutoForm>>
  setFormValid: Dispatch<SetStateAction<boolean>>
}

export const AutoForm: FunctionComponent<Props> = ({
  form,
  setForm,
  setFormValid,
}) => {
  useEffect(() => {
    setForm((prev) => ({
      ...prev,
      property_value: "",
      property_age_at_end: "",
      car_evaluation_score: "",
    }))
  }, [])

  useEffect(() => {
    setFormValid(
      form.branch !== "" &&
        form.gender !== "" &&
        form.familyStatus !== "" &&
        form.employmentSphere !== "" &&
        form.education !== "" &&
        form.collateral !== "" &&
        form.coBorrower !== "" &&
        form.productType !== "" &&
        form.employmentLevel !== "" &&
        form.loanDuration !== "" &&
        form.age !== "" &&
        form.monthlyIncome !== "" &&
        form.workExperience !== "" &&
        form.dependents !== "" &&
        form.cbj_black_list !== "" &&
        form.internal_black_list !== "" &&
        form.inspector_legal_cases !== "" &&
        "property_value" in form &&
        form.property_value !== "" &&
        "property_age_at_end" in form &&
        form.property_age_at_end !== "" &&
        "car_evaluation_score" &&
        form.total_personal_expenses_monthly !== "" &&
        form.active_ahli_bank_monthly_payment !== "" &&
        // form.selected_monthly_payments.length > 0 &&
        form.car_evaluation_score !== "",
    )
  }, [form])

  return (
    <div className={styles.fieldList}>
      <Input
        title="Property value"
        id="property_value"
        value={form.property_value}
        type="integer"
        min={1}
        max={100000000}
        placeholder="min: 1 max: 100000000"
        onInput={(value) => setForm({ ...form, property_value: value })}
      />
      <Input
        title="Property age at loan maturity"
        id="property_age"
        value={form.property_age_at_end}
        type="integer"
        min={0}
        max={100}
        placeholder="min: 0 max: 100"
        onInput={(value) => setForm({ ...form, property_age_at_end: value })}
      />
      <Input
        title="Car evaluation score"
        id="car_evaluation_score"
        value={form.car_evaluation_score}
        type="select"
        options={carEvaluation}
        onSelect={(option) =>
          setForm((prev) => ({
            ...prev,
            car_evaluation_score: option.key,
          }))
        }
      />
    </div>
  )
}
